import { render, staticRenderFns } from "./customerpushlog0512archive-add-or-update.vue?vue&type=template&id=12201aae&"
import script from "./customerpushlog0512archive-add-or-update.vue?vue&type=script&lang=js&"
export * from "./customerpushlog0512archive-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports